<template>
	<sf-modal-layout size="xxl" :title="getMessage_('QWCC001875')" :show="show" :closeModal="close">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<!-- <user-pop-search-view ref="userPopSearchView" :scrId="scrId" :userName="propUserName" /> -->
					<user-pop-search-view ref="userPopSearchView" :scrId="scrId" />
				</sf-card>
			</div>

			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<user-pop-view ref="table" @close="close" @reload="reload" @SendData="sendData" :scrId="scrId" />
				</sf-card>
			</div>
		</div>
		<template v-slot:footer>
			<sf-button line :onClick="() => close()">
				{{ getMessage_('MWCC000343') }}
			</sf-button>
		</template>
	</sf-modal-layout>
</template>

<script>
import { serviceComputed, serviceMethods } from '@qms/comm/commpopup/UserPopup/store/helpers';
import { rootComputed, rootMethods } from '@/store/common/helpers';

import UserPopSearchView from './Content/Search/UserPopSearchView.vue';
import UserPopView from './Content/Table/UserPopView.vue';

export default {
	props: {
		scrId: { type: String, default: '' },
		userName: { type: String, default: '' },
		userGbn: { type: String, default: '' }
		//,tableName: { type: String, default: '' }
	},
	components: { UserPopSearchView, UserPopView },
	// components: { UserPopSearchView },
	data() {
		return {
			show: false,
			propUserName: ''
			// userId: ''
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		open(param) {
			this.show = true;

			this.propUserName = param.userName;

			this.setSearchParam_({ key: 'userId', value: param.userId });
			this.setSearchParam_({ key: 'userName', value: param.userName });
			this.setSearchParam_({ key: 'userGbn', value: param.userGbn });

			if (this.$refs.userPopSearchView != undefined) {
				// console.log('UserPopupView.vue 에서 undefined 확인');
				this.$refs.userPopSearchView.searchList();
			}
			// this.$refs.userPopupView2.onUserPopupParams(param);
			// }
		},
		close() {
			// debugger;
			this.setSearchParam_({ key: 'userId', value: '' });
			this.setSearchParam_({ key: 'userName', value: '' });
			this.setSearchParam_({ key: 'userGbn', value: '' });
			this.setSearchParam_({ key: 'deptName', value: '' });
			this.setSearchParam_({ key: 'remark', value: '' });

			this.$refs.userPopSearchView.reset();
			this.show = false;
		},
		reload(currentPage = 1, pageUnit = 10) {
			this.$refs.userPopSearchView.searchList(currentPage, pageUnit);
		},
		// userGbn은 하나의 Form에 사용자 찾기가 2건이 필요할 경우 해당 값을 셋팅한다.
		sendData(sendParam, userGbn) {
			this.$emit('SendData', sendParam, userGbn);
			this.close();
		}
	}
};
</script>

<style></style>
